// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"df0a4f79","455":"39df1f82","977":"aae33026"}[chunkId] + ".chunk.js";
};